import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import * as HomepageActions from '../actions/homepage.actions';
import { catchError, concatMap, map } from 'rxjs/operators';
import { ConfigurationFacade } from '../facades/configuration.facade';
import { INavigationResponse } from '../models/settings.model';
import { CmsFacade } from '../facades/cms.facade';
import { IContentBanner } from '../models/cms';
import { AppActions, CustomerActions } from '../actions';
import { EFullPageLoaderListOptions } from '../configurations/common';

@Injectable({
  providedIn: 'root',
})
export class HomepageEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);
  private readonly cmsFacade: CmsFacade = inject(CmsFacade);

  readonly initHomepageAfterLogin$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerActions.CompanyUsersActionSuccess),
      map(() => HomepageActions.loadShopCategoryNavigation()),
    );
  });

  readonly GetHomepageShopCategoryOptionsTiles$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(HomepageActions.loadShopCategoryNavigation),
      mergeMap(
        () => this.configurationFacade.getShopCategoryTiles(
        ).pipe(
          map((data: INavigationResponse) =>
            HomepageActions.loadShopCategoryNavigationSuccess({
              navigationResponseNodes: data.data.attributes.nodes,
            }),
          ),
          catchError((error: string) => {
            return of(HomepageActions.loadShopCategoryNavigationFail({resError: error}));
          }),
        ),
      ),
    ));

  readonly GetHomepageShopContentBanner$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(HomepageActions.loadShopContentBanner),
      mergeMap(
        (action) => this.cmsFacade.getContentBannerByKey(action.bannerKey,
        ).pipe(
          concatMap((data: IContentBanner) => {
            return [
              HomepageActions.loadShopContentBannerSuccess({
                contentBannerResponse: data,
              }),
              AppActions.homePageBannerLoaded({name: EFullPageLoaderListOptions.HOMEPAGE_BANNER}),
            ];
          }),
          catchError((error: string) => {
            return of(HomepageActions.loadShopContentBannerFail({resError: error}));
          }),
        ),
      ),
    ));
}
